export default function isClinicalTrialSource(sourceValue: string) {
  try {
    const sourceArray = (process.env.NEXT_PUBLIC_CLINICAL_TRIALS_SOURCE || 'CR')?.split('|');
    if (sourceArray?.includes(sourceValue)) {
      return true;
    }
  } catch (error) {
    return false;
  }
  return false;
}
